var UserModal, user_profile_field;

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import UserItem from 'trunks/vue/admin/components/libs/user_item.js';

import Popover from 'trunks/vue/admin/components/libs/popover.js';

user_profile_field = {
  props: {
    field: {
      type: Object
    }
  },
  computed: {
    showInfo: function() {
      return !this.field.entries.length;
    }
  },
  template: `<div class="information-item">
  <div class="information-title mb-3">{{ field.title }}</div>
  <div class="block-content">
    <div class="content" v-if="showInfo"><span class="time-ago">（未填写）</span></div>
    <div class="content" v-for='entry in field.entries'>
      <div>{{ entry.value }}</div>
    </div>
  </div>
</div>`
};

export default UserModal = Vue.extend({
  components: {
    modal: Modal,
    "user-item": UserItem,
    "user-profile-field": user_profile_field,
    'Popover': Popover
  },
  props: {
    organization: {
      type: Object
    },
    application: {
      type: Object
    },
    applicationTime: {
      type: String
    },
    statusChangeCallback: {
      type: Function
    },
    administrator: {
      type: Object
    },
    accessesList: {
      type: Array
    },
    founded: {
      type: Boolean
    },
    profileSchema: {
      type: Object
    }
  },
  data: function() {
    return {
      profileFields: []
    };
  },
  computed: {
    accessRole: function() {
      return this.administrator.access.name;
    },
    user: function() {
      var ref, ref1;
      return ((ref = this.application) != null ? ref.user : void 0) || ((ref1 = this.administrator) != null ? ref1.user : void 0);
    },
    applicationStatus: function() {
      var ref;
      return (ref = this.application) != null ? ref.status : void 0;
    },
    applicationMessage: function() {
      var ref;
      return (ref = this.application) != null ? ref.message : void 0;
    },
    getProfileSubmissionUrl: function() {
      if (this.administrator) {
        return `/admin/organizations/${this.organization.id}/administrators/${this.administrator.id}/administrator`;
      } else {
        return `/admin/organizations/${this.organization.id}/organization_applications/${this.application.id}/applicant`;
      }
    }
  },
  template: `<modal title="详情" size="small" class="application-user-modal" ref="userInfoModal">
  <template>
    <div class="user-information">
      <div class="information-top">
        <div class="information-item">
          <div class="information-title mb-2">姓名</div>
          <div class="information-text">
            <user-item :user="user"/>
          </div>
        </div>
        <div class="information-item">
          <div class="information-title mb-3">识别码</div>
          <div class="information-text">{{ user.identifier }}</div>
        </div>
        <div class="information-item">
          <div class="information-title mb-3">手机号码</div>
          <div class="information-text">{{ user.phone }}</div>
        </div>
        <div class="information-item" v-if="administrator">
          <div class="information-title mb-3">角色权限</div>
          <div class="information-text">
            <div class="access" v-if="founded">{{ accessRole }}</div>
            <Popover class="bottom" position="top left" customClass="administrator-popover"
                    size="small"
                    ref="popover" v-else>
              <template slot="trigger">
                <span class="mr-1">{{ accessRole }}</span>
                <i class="slp-chevron-down"></i>
              </template>
              <template slot="content">
                <div class="list">
                  <template v-for="access in accessesList">
                    <div class="list-item" @click.stop="accessChange(access)">{{ access.name }}</div>
                  </template>
                </div>
              </template>
            </Popover>
          </div>
        </div>
        <div class="information-item">
          <div class="information-title mb-3">绑定状态</div>
          <div class="information-text">{{ user.openid? '已绑定' : '未绑定' }}</div>
        </div>
        <div class="information-item" v-if="user.tags.length > 0">
          <div class="information-title mb-3">人员标签</div>
          <div class="information-text">
            <template v-for="tag in user.tags">
              <span class="chip mr-2 mt-1">{{ tag.name }}</span>
            </template>
          </div>
        </div>
        <div class="information-item" v-if="applicationStatus == 'approved' || applicationStatus == 'refused'">
          <div class="information-title mb-3">处理结果</div>
          <div class="information-text">
            <button class="text-btn btn-primary" v-if="applicationStatus == 'approved'">已通过</button>
            <button class="text-btn btn-danger" v-if="applicationStatus == 'refused'">已拒绝</button>
          </div>
        </div>
      </div>
      <div class="information-center" v-if="application">
        <div class="information-item">
          <div class="information-title mb-3">
            <span class="mr-2">留言</span>
            <span class="time-ago">{{ applicationTime }}</span>
          </div>
          <div class="information-text">
            <span class="time-ago" v-if="!applicationMessage">（未填写）</span>
            <span>{{ applicationMessage }}</span>
          </div>
        </div>
      </div>
      <div class="information-bottom">
        <user-profile-field v-for="field in profileFields"
                                        :key="field.id"
                                        :field="field"/>
      </div>
    </div>
  </template>
  <template slot="footer">
    <div class="modal-footer">
      <button class="btn-danger"
              v-if="applicationStatus == 'pending'"
              @click.stop='refuse'>拒绝</button>
      <button v-if="applicationStatus == 'pending'" @click.stop='approve'>通过</button>
      <button v-if="applicationStatus == 'approved' || applicationStatus == 'refused' || administrator" @click.stop="close">关闭</button>
    </div>
  </template>
</modal>`,
  created: function() {
    return this._parseProfileFields();
  },
  methods: {
    approve: function() {
      return this.statusChangeCallback('approve');
    },
    refuse: function() {
      return this.statusChangeCallback('refuse');
    },
    accessChange: function(access) {
      return this.statusChangeCallback(access);
    },
    close: function() {
      return this.$refs.userInfoModal.close();
    },
    _parseProfileFields: function() {
      return Skylark.Libs.Ajax.get(this.getProfileSubmissionUrl, {
        responseType: 'json',
        success: (data) => {
          var entries, ref, sortedFields;
          entries = (ref = data.profile_submission) != null ? ref.entries : void 0;
          sortedFields = _.sortBy(this.profileSchema.fields, function(field) {
            field.entries = [];
            return field.position;
          });
          if (entries) {
            _.each(entries, function(entry) {
              var field;
              field = _.find(sortedFields, function(field) {
                return entry.field_id === field.id;
              });
              return field.entries.push(entry);
            });
          }
          return this.profileFields = sortedFields;
        },
        error: function() {
          return Skylark.Bridge.newAlertify('获取自定义字段填写记录失败', {
            type: 'error'
          });
        }
      });
    }
  }
});
